import LoadingToast from './LoadingToast.vue'
export default LoadingToast



// WEBPACK FOOTER //
// ./src/components/loading-toast/index.js